<template>
  <div class="index-image">
    <div class="swiper-container list">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in list" :key="index">
					<img class="img" :src="item.img + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'">
          <div class="userinfo z-flex">
            <img class="avatar" :src="item.avatar || require('@/assets/images/avatar.jpg')">
            <div>
              <div class="z-flex">
                <div class="username">{{ item.username || '游客' }}</div>
                <div class="vip" @click="toVip">
                  <img class="icon" src="@/assets/images/vip.png"/>
                  <span class="text">大扬学院会员</span>
                </div>
              </div>
              <div class="time">{{item.time}} 发布</div>
            </div>
          </div>
          <div class="desc">{{item.teacher_desc}}</div>
          <div class="other-info z-flex z-flex-col">
            <div class="item item-like z-flex z-flex-col z-flex-center" @click.stop="startBubble(item)">
              <i class="iconfont">&#xe673;</i>
              <span class="num">{{item.likes}}</span>
            </div>
            <div class="item z-flex z-flex-col z-flex-center" @click.stop="share(item)">
              <i class="iconfont">&#xe665;</i>
              <span class="num">{{item.shares}}</span>
            </div>
            <!-- <div class="item z-flex z-flex-col z-flex-center">
              <i class="iconfont">&#xe667;</i>
              <span class="num">{{item.comments}}</span>
            </div> -->
          </div>
				</div>
			</div>
			<div class="swiper-button-prev hidden-sm-and-down"><i class="iconfont">&#xe62d;</i></div>
			<div class="swiper-button-next hidden-sm-and-down"><i class="iconfont">&#xe62d;</i></div>
      <!-- heartBubble -->
      <heartBubble v-if="showHeartBubble" class="heartBubble" ref="heartBubble"></heartBubble>
		</div>
    <div class="btn-close z-flex z-flex-center" v-if="isShareReferer == false" @click="goBack"><i class="el-icon-close"></i></div>
     <el-button class="toPK" type="danger" size="medium" v-if="isShareReferer == true" round @click="goBack">参与PK</el-button>
    <!-- 微信h5分享提示 -->
    <div class="weixin-shaare-tips" v-if="showWeixinShareTips">
      <img class="img" src="../assets/images/sharetips.png"/>
    </div>
    <!-- 分享弹窗 -->
    <el-dialog
      custom-class="dialog-share" 
      title="分享链接"
      :visible.sync="showShareDialog"
      :modal="false"
      center
    >
      <el-input v-model="shareUrl" disabled></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showShareDialog = false">取消分享</el-button>
        <el-button type="primary" @click="copyShareUrl">复制链接</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import heartBubble from '@/components/heartBubble'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
  components: {
    heartBubble
  },
  data() {
    return {
        showWeixinShareTips:false,
        showShareDialog:false,
        mode: '0',
        id: '0',
        showHeartBubble: true,
        list: [],
        index: 0, //当前下标
        workId: 0, //作品id
        pkId: 0, //pk活动id
        likeNum: 0, //点赞本次累计
        shareNum: 0, //分享本次累计
        isLikesToDay: true, //是否允许点赞
        timer: null,
        shareUrl:'',
        isShareReferer: false,
    };
  },
  mounted () {
      this.mode = this.$route.query.mode;
      this.id = this.$route.query.id;
      this.shareUrl = window.location.href + '&share=1';
      if (this.$route.query.share) {
        this.isShareReferer = true;
      }
      if (this.mode == '1') {
          //PK活动作品
          this.$axios.api.works({id: this.id}, (res) => {
              if (res.code == 200) {
                  this.isLikesToDay = res.data.isLikesToDay;
                  this.list = res.data.works;
                  this.index = res.data.index;
                  this.$nextTick(()=>{
                    this.init();
                  })
              } else {
                  console.log(res.msg);
              }
          });
      } else {
          //我的作品
          this.$axios.api.myworks({id: this.id, page: 1, pageSize: 1000}, (res) => {
              if (res.code == 200) {
                  this.isLikesToDay = res.data.isLikesToDay;
                  this.list = res.data.works;
                  this.index = res.data.index;
                  this.$nextTick(()=>{
                    this.init();
                  })
              } else {
                  console.log(res.msg);
              }
          });
      }
  },
  methods: {
    goBack(){
      if (this.isShareReferer) {
        this.$router.push({
          path:`/detail?id=${this.pkId}`,
        })
      } else {
        this.$router.go(-1);
      }
    },
    toVip(){
      window.open("https://www.dyyxclub.com/dist/#/vip");
    },
    init(){
        var that = this;
        var mySwiper = new Swiper('.list', {
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer:true, 
            observeParents:true, 
            on:{
                slideChangeTransitionStart: function(){
                    that.showHeartBubble = false;
                },
                slideChangeTransitionEnd: function(){
                    that.showHeartBubble = true;
                },
            },
        });
        mySwiper.slideTo(this.index, 0, false);
        let item = this.list[this.index];
        this.workId = item.id;
        this.pkId = item.pk_id;
        this.timer = setInterval(()=> {
            this.monitor();
        }, 3000);
    },
    share(item){
        this.workId = item.id;
        item.shares++;
        this.shareNum++;
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
            this.showWeixinShareTips = true;
            this.$parent.wxShare(
                    "大扬学院-影像学习综合服务摄影网【大扬学院】",
                    item.title,
                    item.image + '?x-oss-process=image/resize,m_fill,h_100,w_100',
                    this.shareUrl
            );
        } else {
            this.showShareDialog = true;
            // this.$myfun.copyText(location.href);
            // this.$message.success('分享成功，请将网址黏贴到浏览器!');

        }
    },
    copyShareUrl(){
      this.$myfun.copyText(this.shareUrl);
      this.showShareDialog = false;
      this.$message.success('复制成功，去分享给好友吧!');
    },
    startBubble(item){
        if (!this.isLikesToDay) {
            return this.$message.warning('今日点赞数已用完!');
        }
        this.workId = item.id;
        item.likes++;
        this.likeNum++;
        this.$refs.heartBubble.start();
    },
    monitor(){
        if (this.likeNum > 0) {
            let num = this.likeNum;
            this.likeNum = 0;
            this.$axios.api.likes({id: this.workId, num: num}, (res) => {
                if (res.code == 200) {
                    this.isLikesToDay = res.data.isLikesToDay;
                } else {
                    console.log(res.msg);
                }
            });
        }
        if (this.shareNum > 0) {
            let num = this.shareNum;
            this.shareNum = 0;
            this.$axios.api.shares({id: this.workId, num: num}, (res) => {
                if (res.code == 200) {

                } else {
                    console.log(res.msg);
                }
            });
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.index-image{
  width:100%;
  height:100%;
  background:#000;
  position:fixed;
  left:0;
  top:0;
  color: #fff;
  .list{
    width: 100%;
    height: 100%;
    .swiper-slide{
      display:flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;
      .img{
        max-width:100vw;
        max-height:100vh;
      }
      .userinfo{
        position: absolute;
        top: 20px;
        left: 20px;
        .avatar{
          width:60px;
          height:60px;
          border-radius: 50%;
          margin-right: 15px;
          box-shadow: 0 0 10px rgba(0,0,0,.5);
        }
        .username{
          font-size: 16px;
          margin-bottom: 8px;
          text-shadow: 0 0 5px rgba(0,0,0,.75);
          max-width:calc(100vw - 380px);
          margin-right: 20px;
          @extend %textOverflow;
        }
        .vip{
          position: relative;
          margin-top: -8px;
          cursor: pointer;
          .icon{
            height:25px;
            position:absolute;
            left:-14px;
            bottom:-5px;
          }
          .text{
            background:#fadab0;
            color:#552904;
            font-size: 12px;
            padding:1px 4px 2px 12px;
            border-radius: 4px;
          }
        }
        .time{
          font-size: 14px;
          text-shadow: 0 0 5px rgba(0,0,0,.75);
        }
      }
      .desc{
        width: calc(100% - 180px);
        color: #fff;
        position: absolute;
        bottom: 20px;
        left: 20px;
        z-index: 9;
        line-height: 1.6;
        @include textOverflowNum(3);
      }
      .other-info{
        position:absolute;
        right:0;
        bottom:30px;
        border-radius: 4px;
        z-index: 20;
        .item{
          padding: 15px;
          cursor: pointer;
          height: 100%;
          text-shadow: 0 2px 8px #000;
          .iconfont{
            font-size: 30px;
            margin-bottom: 8px;
            
          }
          .num{
            font-family: Arial, Helvetica, sans-serif;
            font-size: 16px;
          }
        }
      }
    }
  }
  .btn-close{
    width:50px;
    height:50px;
    border-radius: 50%;
    background:rgba(0,0,0,.6);
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 2;
    i{
      font-size: 35px;
    }
  }
  .toPK{
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 2;
  }
}
.swiper-button-prev,.swiper-button-next{
  outline:none;
  width:44px;
  background:rgba(0,0,0,.5);
  border-radius: 50%;
  display:flex;
  justify-content: center;
  align-items: center;
  .iconfont{
    font-size: 22px;
  }
}
.swiper-button-prev{
  .iconfont{
    transform:rotate(180deg);
  }
}
.heartBubble{
  position: absolute;
  right: -10px;
  bottom: 190px;
  z-index: 10;
}
.weixin-shaare-tips{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background: rgba(0,0,0,.7);
  .img{
    width: 100%;
    height: auto;
  }
}
::v-deep .dialog-share{
  margin-top: 0!important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 500px;
}

@media screen and (max-width:768px){
  .index-image{
    .list{
      .swiper-slide{
        .userinfo{
          top: 10px;
          left: 10px;
          .avatar{
            width:36px;
            height:36px;
            margin-right: 10px;
          }
          .username{
            font-size: 14px;
            margin-bottom: 2px;
            margin-right: 10px;
            max-width:calc(100vw - 280px);
          }
          .vip{
            transform:scale(.85);
            margin-top: -4px;
          }
          .time{
            font-size: 12px;
          }
        }
        .desc{
          width: calc(100% - 100px);
          font-size: 14px;
        }
        .other-info{
          .item{
            padding: 10px;
            .iconfont{
              font-size: 24px;
            }
            .num{
              font-size: 14px;
            }
          }
        }
      }
    }
    .btn-close{
      width:36px;
      height:36px;
      top: 10px;
      right: 10px;
      i{
        font-size: 28px;
      }
    }
    .toPK{
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 2;
      padding: 8px 12px;
      font-size: 12px;
    }
  }
  .heartBubble{
    bottom: 160px;
    right: -20px;
  }
  ::v-deep .dialog-share{
    width: 90%;
  }
}
</style>
